<template>
  <div class="card" :key="`${task.id}`" @click="selectTask(task)">
    <img class="card-image" :src="task.task_thumbnail" />
    <p class="card-name" :id="`card-name-${task.id}`">
      {{ task.task_name }}
    </p>
    <p class="label">Summary:</p>
    <p class="text">{{ task.summary }}</p>
    <p class="label">Topic:</p>
    <p class="text">{{ task.topic }}</p>
    <p class="label">Language:</p>
    <p class="text">{{ language }}</p>
    <p class="label">Level:</p>
    <p class="text">{{ level }}</p>
    <p class="label">Country:</p>
    <p class="text">{{ country }}</p>
    <b-tooltip :target="`card-name-${task.id}`" triggers="hover" placement="bottom">
      {{ task.task_name }}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'Card',
  data() {
    return {}
  },
  props: {
    task: {
      type: Object,
      default: () => ({
        id: 1
      })
    }
  },
  methods: {
    truncateString(str, num) {
      return str?.length > num ? str.slice(0, num) + '...' : str
    },
    selectTask(task) {
      this.$emit('task-selected', task)
    }
  },
  computed: {
    language() {
      return this.task?.task_language?.name
    },
    level() {
      return this.task?.level?.name
    },
    country() {
      return this.task?.country?.name
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/core/styles/variables.styl"
.card
  text-align center
  font font-opensans-semibold
  width 200px
  padding 0 30px
  padding-top 8px
  border 2px solid color-3
  color color-3
  border-radius 40px
  margin 0 10px
  position relative
  margin-bottom 10px
  cursor pointer
  background-color color-57
  min-height 330px
  border color-3 2px solid

  .card-image
    object-fit cover
    width 100%
    height 80px
    margin-bottom 5px

  .card-name
    text-transform uppercase
    margin-bottom 10px
    width 100%
    text-overflow ellipsis
    white-space nowrap
    overflow hidden

  .label, .text
    text-align left
    margin 0
    font font-opensans-semibold
    font-size 14px

  .text
    text-overflow ellipsis
    white-space nowrap
    overflow hidden
    color color-8

  .label--level
    font font-opensans-regular
    font-size 14px
</style>
